import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import moment from "moment/moment";

interface IAssignmentLinkField {
  routeName: string;
  isLastIteration: boolean;
}

const useStyles = makeStyles({
  root: {
    textDecoration: "none",
    color: "#3f51b5",
  },
});

const AssignmentLinkField = ({
  routeName,
  isLastIteration,
}: IAssignmentLinkField) => {
  const classes = useStyles();

  return (
    <>
      <Link
        to={`/assignments?filter=${JSON.stringify({
          EstimatedStartedAt: moment().format("Y-MM-DD"),
          search: routeName,
        })}`}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.root}
      >
        {routeName}
      </Link>

      {!isLastIteration && ", "}
    </>
  );
};

export default AssignmentLinkField;
